module.exports = __webpack_public_path__ + "static/media/story.2f73b3d8.jpg";